export default __webpack_public_path__ + "static/media/logout-white.26ff2b97.svg";